export const CURRENCIES = process.env?.REACT_APP_AVAILABLE_CURRENCIES.split(',') ?? ['USD', 'EUR']

export const DEFAULT_LOCALE = process.env?.REACT_APP_DEFAULT_LOCALE || 'en'

export const AVAILABLE_LOCALES = process.env?.REACT_APP_AVAILABLE_LOCALES || 'en'

export const LOCALES = AVAILABLE_LOCALES.split(',')

export const PAYOUT_TYPES = ['capitalist']

export const WALLET_PREFIX = {
  capitalist: 'U',
  any: '',
}

export const AVAILABLE_CURRENCIES = {
  capitalist: [process.env?.REACT_APP_DEFAULT_CURRENCY ?? 'USD'],
  any: CURRENCIES,
}

export const APP_PRODUCT = process.env.REACT_APP_PRODUCT
export const APP_PRODUCT_PUBLIC_NAME = process.env.REACT_APP_PRODUCT_PUBLIC_NAME

export const REACT_APP_DOMAIN = process.env.REACT_APP_DOMAIN

export const REACT_APP_PROTOCOL = process.env.REACT_APP_PROTOCOL

export const STATISTICS_NETWORKS_LIST = ['googleads']
